import request from '@/utils/request'


//年龄
export function getBdAge() {
    return request.get(`/open/constant/baidu/age`)
}

//安卓手机品牌
export function getBdAndroidBrands() {
    return request.get(`/open/constant/baidu/android_brands`)
}

//操作系统
export function getBdDevice() {
    return request.get(`/open/constant/baidu/device`)
}

//教育
export function getBdEducation() {
    return request.get(`/open/constant/baidu/education`)
}

//排除已转化人群
export function getBdExcludeTrans() {
    return request.get(`/open/constant/baidu/exclude_trans`)
}

//ios版本
export function getBdIosVersion() {
    return request.get(`/open/constant/baidu/ios_version`)
}

//人生阶段
export function getBdLifeStage() {
    return request.get(`/open/constant/baidu/life_stage`)
}

//网络
export function getBdNet() {
    return request.get(`/open/constant/baidu/net`)
}

//用户到访类型
export function getBdUserActionType() {
    return request.get(`/open/constant/baidu/user_action_type`)
}

//性别
export function getBdGender() {
    return request.get(`/open/constant/baidu/gender`)
}

//性别
export function getBdkeywordsExtend() {
    return request.get(`/open/constant/baidu/keywords_extend`)
}

//流量类型
export function getBdTypes() {
    return request.get(`/open/constant/baidu/ftypes`)
}

//转化类型
export function getBdTransTypes() {
    return request.get(`/open/constant/baidu/trans_types`)
}
